import { render } from "./CartDrawerKitItem.vue?vue&type=template&id=b3700052"
import script from "./CartDrawerKitItem.vue?vue&type=script&lang=js"
export * from "./CartDrawerKitItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__